import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

// Definir interfaces localmente
export interface User {
  id: string;
  email: string;
  name: string;
  role: string;
  avatarUrl?: string;
  phone?: string;
}

export interface Project {
  id: string;
  name: string;
  description?: string;
  clientId: string;
  projectLeadId?: string;
  address?: string;
  status: 'planning' | 'in_progress' | 'completed' | 'cancelled';
  budget: number;
  createdAt?: number;
  updatedAt?: number;
}

export interface ProjectWithDetails extends Project {
  clientName?: string;
  projectLeadName?: string;
  advancePercentage?: number;
  teamMembers?: User[];
}

export const projectService = {
  async getProjects(): Promise<ProjectWithDetails[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/projects`);
    return response.data || [];
  },

  async getProject(id: string): Promise<ProjectWithDetails> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/projects/${id}`);
    return response.data;
  },

  async createProject(data: Partial<Project>): Promise<Project> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/projects`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async updateProject(id: string, data: Partial<Project>): Promise<Project> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/projects/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return response.data;
  },

  async deleteProject(id: string): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/projects/${id}`, {
      method: 'DELETE',
    });
  },

  async getTeam(projectId: string): Promise<User[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/projects/${projectId}/team`);
    return response.data || [];
  },

  async updateTeam(projectId: string, teamIds: string[]): Promise<void> {
    await authService.fetchWithAuth(`${API_URL}/api/projects/${projectId}/team`, {
      method: 'PUT',
      body: JSON.stringify({ teamIds }),
    });
  },

  async getAvailableStaff(): Promise<User[]> {
    const response = await authService.fetchWithAuth(`${API_URL}/api/staff/available`);
    return response.data || [];
  }
};